import React from 'react';
import { StepProps, ApplicationType } from '../MortgageApplicationPage';
import {
    MultistepForm,
    SetSubmitError,
    SetIsLoading,
    InputType
} from 'view/components/common';
import { isRequired } from 'core/utilities';
import { updateApplication } from 'core/api';
import { useToast } from 'core/toast';

type FormValues = {
    mortgage_type : ApplicationType;
};

export const MortgageType : React.FunctionComponent<StepProps> = ({
    application,
    step, 
    setStep,
    progressForward,
    progressBackward,
    setMortgageType
}) => {
    const { setToastMessage } = useToast();
    const onExit = () => {
        setStep(s => s - 1);
        progressBackward();
    };

    const { id } = application;

    const onSubmit = (_: SetSubmitError, setIsLoading : SetIsLoading) => {
        return async (payload : FormValues) => {
            const { mortgage_type : _type } = payload;

            setIsLoading(true);
            setMortgageType(_type);
            const { success } = await updateApplication(id, { _type });
    
            if (success) {
                setTimeout(() => {
                    setStep(s => s + 1);
                    progressForward();
                }, 500);
            } else {
                setIsLoading(false);
                setToastMessage();
            }
        };
    };

    return (
        <MultistepForm
            title='Application Type'
            backText='Back'
            stepTitle={() => `Step ${step}`}
            onExit={onExit}
            initialValues={{}}
            formSteps={[
                [ {
                    type : InputType.choice,
                    name : 'mortgage_type',
                    validator: isRequired
                } ]
            ]}
            onSubmit={onSubmit}
        />
    );
};
